import { useTranslation } from 'react-i18next'

import { useSocialUniverse } from '@/pages/KnowledgeHubPage/social/useSocialUniverse'
import { ROUTES } from '@/routes/routes'
import Link from '@/routing/Link'

export interface ThreadSocialTopicLinkProps {
  topicToken: string
}

/**
 * The thread header's mention of its focused Topic, by the Topic's current
 * name, linking back to its page. Nothing while the name loads or when the
 * Topic cannot be read (deleted, or another organization's).
 */
export function ThreadSocialTopicLink(props: ThreadSocialTopicLinkProps) {
  const { topicToken } = props

  const { t } = useTranslation('app')

  const { universe } = useSocialUniverse(topicToken)

  if (!universe) {
    return null
  }

  return (
    <Link
      href={ROUTES.knowledgeTopic(topicToken)}
      className="min-w-0 truncate text-xs text-muted-foreground hover:text-foreground"
      data-testid="thread-social-topic-link"
    >
      {t('socialListening.topicAsk.threadTopic', { name: universe.name })}
    </Link>
  )
}
